import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

export const companyProfileRoutes: RouteObject[] = [
  { path: '/company-profile', lazy: page(() => import('./pages/CompanyProfileListPage.js')) },
  { path: '/company-profile/customers/:customerId', lazy: page(() => import('./pages/CompanyProfilePage.js')) },
];
